import $ from 'jquery';
import LOGGER from '@component/common/src/util/Logger';
import PageApp from 'pageApp';
import './scss/_dontExtract_/pros-factory.scss';
import ProsApp from './ProsApp';
import MainPageController from './controller/MainPageController';
import ResponsiveBagController from './controller/ResponsiveBagController';
import RecommendationStore from './store/RecommendationStore';
import ProsRedesignExperimentDecider from './util/ProsRedesignExperimentDecider';

const PageAppChannel = PageApp.channel;


/**
 {
     requester:"MCOM-NAVAPP" or "MCOM-MMEW",
     zone:"PDP_ZONE_A" or "PDP_ZONE_A|PDP_ZONE_B",
     recommendationConfig : {
        maxRecommendations : 15 or 25 or 75 any number,
        productId : actual-product-id or -9,
        categoryId : category of product if available,
        productIds : for shopping bag page if available,
    },
     panelConfig:{
        element : mandatory dom-element-selector or dom-element like "#prosPanel" or $("#prosPanel"),
        pageSize : no of products to show on big screen (default is 6),
        orientation : horizontal or vertical (default is horizontal),
        autoScrollTime : if you want carousel panel to autoscroll, give some time in milliseconds,
        viewType : render grid or carousel (default is undefined, means carousel),

     },

     properties:{
        discovery : to consume discovery-xapi or not (default is false),
        pixelPresentedEnabled : to fire pixel-presented-event to pros-service or not (default true),
        fccFallbackEnabled : Whether it should fallback to FCC or not (default is true)
     }

 }

 */
PageAppChannel.on('pros-factory:render:zone', ({
  zone,
  uniqueId,
  recommendationConfig,
  panelConfig,
  properties,
}) => {
  const isZoneExperimented = ProsRedesignExperimentDecider.isZoneExperimented(zone);
  if (!isZoneExperimented && recommendationConfig) {
    ProsApp.getRecommendations(
      Object.assign({ zone, uniqueId }, recommendationConfig),
      properties, panelConfig.element,
    );
  }
  ProsRedesignExperimentDecider.getPanelConfigurationOrDefault(panelConfig, properties, recommendationConfig, zone)
    .then((panelProps) => {
      if (!panelProps.panelInDisguise) {
        if (isZoneExperimented && recommendationConfig) {
          ProsApp.getRecommendations(
            Object.assign({ zone, uniqueId }, recommendationConfig),
            properties, panelConfig.element,
          );
        }

        ProsApp.createPanel(Object.assign({
          zone,
          uniqueId,
          productId: recommendationConfig.productId,
        }, panelConfig), panelProps);
      }
    });

  ProsApp.getHeartingListHistory();
});


/**
 {
     requester:"MCOM-NAVAPP" or "MCOM-MMEW",
     zone:"PDP_ZONE_A" or "PDP_ZONE_A|PDP_ZONE_B",
     recommendationConfig : {
        maxRecommendations : 15 or 25 or 75 any number,
        productId : actual-product-id or -9,
        categoryId : category of product if available,
        productIds : for shopping bag page if available,

    },
    properties:{
       fccFallbackEnabled :  Whether it should fallback to FCC or not (default is true)
    }
 }

 */
PageAppChannel.on('pros-factory:get:recommendation', ({
  zone,
  recommendationConfig,
}) => {
  ProsApp.getRecommendations(Object.assign({ zone }, recommendationConfig));
});

PageAppChannel.on('pros-carousel-rendered', ({
  requester,
  zone,
}) => {
  if (requester && zone) {
    RecommendationStore.clear(`${requester}-${zone}`);
  }
});

PageAppChannel.on('pros-carousel-render-failed', (opts) => {
  if (opts && opts.element) {
    $(opts.element).hide();
  }
});


const PAGE_CONTROLLERS = {
  RESPONSIVE_BAG: ResponsiveBagController,
  // future controllers will go here
};

/**
 * Try to find page specific controller, as we need to add page specific logic
 * like:
 * for responsive bag: get last and second last product-id from bagObject, or rvi product-id
 * for home page: get rvi product-id, currenly not implemented, so it uses MainPageController
 * for cat splash page: do nothing -> uses MainPageController
 * @param opts
 * @returns {*}
 */
const getPageSpecificController = (opts) => {
  if (opts && opts.page && PAGE_CONTROLLERS[opts.page]) {
    const { page, data, options } = opts;
    return new PAGE_CONTROLLERS[page](data, Object.assign({ page }, options));
  }
  // deal with generic controller
  return new MainPageController(opts);
};


// Provide Opts in the format of {page, data}
PageAppChannel.on('pros-factory:initialize', (opts) => {
  try {
    const controller = getPageSpecificController(opts);
    controller.render();
  } catch (error) {
    LOGGER.error('Pros-factory ProsApp.js pros-factory:initialize got error : ', error);
  }
});


PageAppChannel.on('feature::pros-factory::enableHeart', (productId) => {
  $(`#${productId}`).find('.altContainer').removeClass('icon-gen-heart-gr-large').addClass('icon-gen-heart-red-large');
});

